import pageRoutes from '../../router/pageRoutes';
import { toAbsoluteUrl } from './urls';

// Stable identifier for the company entity. Every other node in the graph references this instead
// of restating the company details, so "Gaspar AI" resolves to one entity rather than several.
export const OrganizationId = toAbsoluteUrl('/#organization');
export const OrganizationLogoId = toAbsoluteUrl('/#logo');

/**
 * The logo used to point at /favicon.png, which is a byte for byte copy of favicon.ico carrying a
 * .png extension. Consumers that actually decode the image reject it, because it is not a PNG.
 * /static/logo.png is a real PNG. At 59x48 it is still below the 112x112 Google asks for, so this
 * is the single constant to repoint once a larger raster logo exists.
 */
export const OrganizationLogo = { url: toAbsoluteUrl('/static/logo.png'), width: 59, height: 48 };

// NOTE: foundingDate and address are deliberately absent. Neither is recorded anywhere in this
// repository, and inventing them would publish false claims about the company as structured data.
const organizationJsonLd = {
  '@type': 'Organization',
  '@id': OrganizationId,
  name: 'Gaspar AI',
  legalName: 'Gaspar AI',
  url: toAbsoluteUrl('/'),
  description: 'Generative AI employee help desk to auto-resolve issues.',
  logo: {
    '@type': 'ImageObject',
    '@id': OrganizationLogoId,
    url: OrganizationLogo.url,
    width: OrganizationLogo.width,
    height: OrganizationLogo.height,
    caption: 'Gaspar AI',
  },
  image: { '@id': OrganizationLogoId },
  sameAs: ['https://www.linkedin.com/company/gasparai', 'https://twitter.com/gaspardesk1'],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      url: toAbsoluteUrl(pageRoutes.ContactUs),
      availableLanguage: ['en'],
    },
  ],
};
export default organizationJsonLd;
